import { render, staticRenderFns } from "./BussinessPartner.vue?vue&type=template&id=19f6f7cc&"
import script from "./BussinessPartner.vue?vue&type=script&lang=js&"
export * from "./BussinessPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports